module.exports = __webpack_public_path__ + "img/director.18df42e9.png";